import {
  Box,
  Button,
  Center,
  Heading,
  Input,
  Link,
  Text
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { useRegister } from 'hooks/auth';
import { APP_DASHBOARD, LOGIN } from 'lib/routes';
import {
  emailValidate,
  passwordValidate,
  usernameValidate
} from 'utils/forms-validate';

import { Field } from '../../components/ui/field';

export default function Register(props) {
  const { register: signup, isLoading } = useRegister();
  const { register, handleSubmit, reset, formState } = useForm();

  async function handleRegister(data) {
    const succeeded = await signup({
      username: data.username,
      email: data.email,
      password: data.password,
      redirectTo: APP_DASHBOARD
    });

    if (succeeded) reset();
  }

  return (
    <Center w="100%" h="100vh">
      <Box mx="1" maxW="md" p="9" borderWidth="1px" borderRadius="lg">
        <Heading mb="4" size="lg" textAlign="center">
          Sign Up!
        </Heading>

        <form onSubmit={handleSubmit(handleRegister)}>
          <Field
            errorText={formState.errors.email?.message}
            py="2"
            label="Username"
          >
            <Input
              type="username"
              placeholder="chillbuddy"
              data-lpignore="true"
              {...register('username', usernameValidate)}
            />
          </Field>
          <Field
            errorText={formState.errors.username?.message}
            py="2"
            label="Email"
          >
            <Input
              type="username"
              placeholder="user@email.com"
              data-lpignore="true"
              {...register('email', emailValidate)}
            />
          </Field>
          <Field
            errorText={formState.errors.password?.message}
            py="2"
            label="Password"
          >
            <Input
              type="password"
              placeholder="abcd1234"
              data-lpignore="true"
              {...register('password', passwordValidate)}
            />
          </Field>

          <Button
            mt="4"
            type="submit"
            colorPalette="themeColor"
            size="md"
            width="full"
            isLoading={isLoading}
            loadingText="Signing Up"
          >
            Sign Up!
          </Button>
        </form>

        <Text fontSize="xlg" align="center" mt="6">
          Already have an account?{' '}
          <Link
            as={RouterLink}
            to={LOGIN}
            color="themeColor"
            fontWeight="medium"
            textDecor="underline"
            _hover={{ background: 'themeColor' }}
          >
            Login
          </Link>{' '}
          instead!
        </Text>
      </Box>
    </Center>
  );
}
